import { ReactComponent as Check } from "../../assets/icons/nonCheck.svg";
import { ReactComponent as RoundCheck } from "../../assets/icons/checkbox_round_off.svg";
import { ReactComponent as SquareCheck } from "../../assets/icons/checkbox_square_off.svg";

export default function Checkbox({ type, ...rest }: { type: "round" | "line" | "square"; [key: string]: any }) {
    let checkbox;

    if (type === "line") {
        checkbox = <Check className="peer-checked:[&_path]:stroke-[#4B632B]" />;
    } else if (type === "round") {
        checkbox = <RoundCheck className="peer-checked:[&_path]:fill-[#4B632B]" />;
    } else if (type === "square") {
        checkbox = (
            <SquareCheck className="[&_path:nth-child(1)]:fill-[#ddd] [&_path:nth-child(2)]:fill-[#fff] peer-checked:[&_path:nth-child(1)]:fill-[#4B632B]" />
        );
    }

    return (
        <div className="relative">
            <input
                type="checkbox"
                className={`peer appearance-none !absolute inset-0 z-[10] !bg-transparent before:!content-none !border-none overflow-hidden disabled:cursor-not-allowed`}
                {...rest}
            />
            {checkbox}
        </div>
    );
}
